import { supabase } from '../supabaseClient';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const SHA256_RE = /^[0-9a-f]{64}$/;

function requiredUuid(value, label) {
  const normalized = String(value || '').trim();
  if (!UUID_RE.test(normalized)) throw new Error(`${label} invalide.`);
  return normalized;
}

function normalizeDraft(row, expected = {}) {
  const value = Array.isArray(row) ? row[0] : row;
  const clientId = requiredUuid(value?.clientId, 'Cliente');
  const consultationId = requiredUuid(value?.consultationId, 'Consultation');
  const revision = Number(value?.revision);
  const text = String(value?.text || '');
  if (value?.version !== 1 || clientId !== expected.clientId
      || consultationId !== expected.consultationId
      || !Number.isSafeInteger(revision) || revision < 0
      || text.length > 100000
      || (revision === 0 && value?.contentSha256 !== null)
      || (revision > 0 && !SHA256_RE.test(value?.contentSha256 || ''))
      || typeof value?.reviewConfirmed !== 'boolean') {
    throw new Error('Brouillon d’explication invalide.');
  }
  return Object.freeze({
    clientId,
    consultationId,
    text,
    contentSha256: value.contentSha256,
    revision,
    reviewConfirmed: value.reviewConfirmed,
    updatedAt: value.updatedAt || null,
  });
}

export async function loadResultsExplanationDraft({ clientId, consultationId }, db = supabase) {
  const expected = {
    clientId: requiredUuid(clientId, 'Cliente'),
    consultationId: requiredUuid(consultationId, 'Consultation'),
  };
  const { data, error } = await db.rpc('lire_brouillon_explication_resultats_cliente', {
    p_client_id: expected.clientId,
    p_consultation_id: expected.consultationId,
  });
  if (error || !data) {
    throw new Error(error?.message || 'Le brouillon d’explication est inaccessible.');
  }
  return normalizeDraft(data, expected);
}
export async function saveResultsExplanationDraft({
  clientId,
  consultationId,
  text,
  reviewConfirmed = false,
  expectedRevision,
}, db = supabase) {
  const expected = {
    clientId: requiredUuid(clientId, 'Cliente'),
    consultationId: requiredUuid(consultationId, 'Consultation'),
  };
  const revision = Number(expectedRevision);
  const normalizedText = String(text || '').replace(/\r\n/g, '\n');
  if (!Number.isSafeInteger(revision) || revision < 0) {
    throw new Error('Version du brouillon invalide.');
  }
  if (normalizedText.length > 100000) {
    throw new Error('L’explication est trop longue.');
  }
  const { data, error } = await db.rpc('sauvegarder_brouillon_explication_resultats_cliente', {
    p_client_id: expected.clientId,
    p_consultation_id: expected.consultationId,
    p_expected_revision: revision,
    p_review_confirmed: reviewConfirmed === true,
    p_text: normalizedText,
  });
  if (error || !data) {
    throw new Error(error?.message || 'Le brouillon d’explication n’a pas été enregistré.');
  }
  return normalizeDraft(data, expected);
}
